import { AloftDate, isDefined } from '@aloft/toolkit-shared';

import { CompWithSaleInfo, Tkv2MarketConditionsState } from '../types.js';

export function getCompsWithSaleInfo(
  comps: Tkv2MarketConditionsState['comps'],
): CompWithSaleInfo[] {
  return Object.entries(comps)
    .map(([compID, comp]) => {
      if (comp.property.getStructuredData('status')?.listingStatus !== 'SettledSale') {
        return;
      }
      // For each comp we want to parse out its month of sale (contract or closed date)
      const status = comp.property.getStructuredData('status');

      const month = status?.contractMonth ?? status?.closeMonth;
      const monthAsDate = month === undefined ? undefined : AloftDate.fromIsoString(`${month}-01`);
      const price = comp.property.getStructuredData('salePrice');

      return { compID, month, monthAsDate, price };
    })
    .filter(isDefined);
}
